// Port Wingo UI → React 18 (copiat din ERP; pe React 19 forwardRef merge în continuare, deci nu l-am scos): pe React 19 `ref` ajunge în props ca orice prop; pe React 18 o componentă-funcție
// îl primește doar prin forwardRef. withRef învelește randarea originală (care citește `props.ref`) într-un
// forwardRef și îi pune ref-ul înapoi în props, ca sursa componentei să rămână aproape neatinsă.
// Tipul întors e chiar semnătura originală, deci JSX-ul consumatorilor se verifică la fel ca în wingo.
import { forwardRef, type ReactElement, type ReactNode } from "react";

export function withRef<P>(render: (props: P) => ReactNode, displayName: string): (props: P) => ReactElement | null {
  const Component = forwardRef<unknown, P>((props, ref) =>
    render((ref ? { ...props, ref } : props) as P) as ReactElement | null,
  );
  Component.displayName = displayName;
  return Component as unknown as (props: P) => ReactElement | null;
}

// Portalul de client e pe React 19, care tratează `inert` ca boolean: un șir gol (forma cerută de React 18 în
// ERP) ar fi citit ca `false` și elementul ar rămâne activ. Componentele copiate din ERP cheamă tot
// {...inertProps(cond)}, deci aici întoarcem `true`.
export function inertProps(inert: boolean | undefined): Record<string, unknown> {
  return inert ? { inert: true } : {};
}

// React 19 cheamă cleanup-ul întors de un ref callback la detașare (și nu-l mai cheamă cu null); React 18 ignoră
// valoarea întoarsă și cheamă ref-ul cu null. refCleanup ține cleanup-ul în closure și îl rulează la următorul apel,
// ca sursa wingo (`attach` întoarce cleanup) să rămână neschimbată. `attach` primește doar elemente, nu null.
export function refCleanup<T>(attach: (el: T) => (() => void) | void): (el: T | null) => void {
  let cleanup: (() => void) | void;
  return (el) => {
    if (cleanup) {
      const run = cleanup;
      cleanup = undefined;
      run();
    }
    if (el) cleanup = attach(el);
  };
}

// fuziunea de ref-uri pe React 18: fiecare ref primește nodul, iar la detașare null (fără cleanup întors)
export function assignRefs<T>(node: T | null, ...refs: unknown[]): void {
  for (const ref of refs) {
    if (typeof ref === "function") ref(node);
    else if (ref && typeof ref === "object") (ref as { current: T | null }).current = node;
  }
}
